import { render } from "./ListDataIzin.vue?vue&type=template&id=f02c89ee"
import script from "./ListDataIzin.vue?vue&type=script&lang=js"
export * from "./ListDataIzin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__